import { useEffect, useState } from 'react';
import { Range } from 'slate';
import { useSlate } from 'slate-react';

export const useLastActiveSelection = () => {
  const editor = useSlate();
  const [lastActiveSelection, setLastActiveSelection] = useState<Range>({
    anchor: {
      offset: 0,
      path: [0, 0],
    },
    focus: {
      offset: 0,
      path: [0, 0],
    },
  });

  useEffect(() => {
    if (editor.selection != null) {
      setLastActiveSelection(editor.selection);
    }
  }, [editor.selection]);

  return {
    lastActiveSelection,
  };
};
